import type {FC} from 'react';
import {DUMMY_COMMENTS} from '../../../constants/dummyComments';
import {AuthActionButtons} from './AuthActionButtons';

type Props = {
  isStudentVerificationRequired?: boolean;
};

export const UnauthenticatedCommentList: FC<Props> = ({
  isStudentVerificationRequired = false,
}) => {
  return (
    <div className="relative p-16">
      <div className="blur-[4px] pointer-events-none select-none">
        <ul>
          {DUMMY_COMMENTS.map((comment) => (
            <li key={comment.id} className="py-12 border-b border-line">
              <p className="text-sm text-black-2">{comment.nickname}</p>
              <p className="text-base text-black-1 mt-4">{comment.content}</p>
            </li>
          ))}
        </ul>
      </div>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <p className="text-center text-black-1 text-base font-bold mb-12">
          {isStudentVerificationRequired
            ? '大学認証を完了するとコメントが閲覧できます'
            : '会員登録するとコメントが閲覧できます'}
        </p>
        <AuthActionButtons
          isStudentVerificationRequired={isStudentVerificationRequired}
        />
      </div>
    </div>
  );
};
